import { DipendenteVO } from "../dipendenteVO";
import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";

export class DestinatarioDipendenteVO {
  dipendente: DipendenteVO = new DipendenteVO();
  competenza: TipoDestinatarioEnum;
}
